document.addEventListener('DOMContentLoaded', function() {
  announceSliderTorigger();
  headerMenuHoverTorigger();
  headerMenuDetailsTorigger();
  mvSliderTorigger();
  featuredSliderTorigger();
  sceneSliderTorigger();
  colFilterMaxpriceWidthToggle();
  relatedProductSliderTorigger();
});

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      announceSliderTorigger();
      headerMenuHoverTorigger();
      headerMenuDetailsTorigger();
      mvSliderTorigger();
      featuredSliderTorigger();
      sceneSliderTorigger();
      relatedProductSliderDesignmode();
    });
}

if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
      announceSliderTorigger();
      headerMenuHoverTorigger();
      headerMenuDetailsTorigger();
      mvSliderTorigger();
      featuredSliderTorigger();
      sceneSliderTorigger();
    });
}

if (Shopify.designMode) {
    document.addEventListener('shopify:section:select', (e) => {
      announceSliderTorigger();
      headerMenuHoverTorigger();
      headerMenuDetailsTorigger();
      mvSliderTorigger();
      featuredSliderTorigger();
      sceneSliderTorigger();
    });
}


/****************************************
      アナウンスバーのスライダーJS
****************************************/
function announceSliderTorigger() {
    if (document.querySelectorAll('.c-announcement-bar__section') !== null) {
        announceSlider();
    }
};

function announceSlider () {
    $('.c-announcement-bar__section').each(function() {
        const $slideSection = $(this);
        const $slick = $slideSection.find('.slider');
      
        $slick.slick({
            autoplay: true,
            autoplaySpeed: 4000,
            arrows: true,
            slidesToShow: 1,
            speed: 1000,
            prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0784/8732/2922/files/arrow-left.svg?v=1694070719" class="slide-arrow prev-arrow">',
            nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0784/8732/2922/files/arrow-right.svg?v=1694070719" class="slide-arrow next-arrow">',
        });
    });
};


/****************************************
        ヘッダーメニューのホバーJS
****************************************/
function headerMenuHoverTorigger() {
    if (document.querySelectorAll('.c-header__details__hover') !== null) {
        headerMenuHover();
    }
};

function headerMenuHover() {
  const hasSubmenuItems = document.querySelectorAll('.c-header__details__hover');
  
    hasSubmenuItems.forEach(function(hasSubmenuItem) {
      hasSubmenuItem.addEventListener('mouseover', function(e) {
          this.setAttribute('open', true);
      });
      hasSubmenuItem.addEventListener('mouseleave', function(e) {
          this.removeAttribute('open', false);
      });
  });
}


/****************************************
        ヘッダーメニューのDetailsのアニメーションJS
****************************************/
function headerMenuDetailsTorigger() {
    if (document.querySelector('header-menu') !== null) {
        headerMenuDetails();
    }
};

function headerMenuDetails() {
  const headerMenu = document.querySelector('header-menu');
  const details = headerMenu.firstElementChild;
  if (details.classList.contains('c-header__details__hover')) {
    const summary = details.firstElementChild;
      summary.addEventListener('mouseover', (e) => {
        e.preventDefault();
        if (!details.open) {
          details.open = true;
          setTimeout(() => {
            details.classList.add('is-opened'); 
          }, 5);
        } else if (details.open) {
          details.classList.remove('is-opened'); 
          setTimeout(() => {
            details.open = false;
          }, 255);
        }
      });
    
    details.addEventListener('toggle', () => {
      const hasOpenedClass = details.classList.contains('is-opened');
    
      if (details.open && !hasOpenedClass) {
        details.classList.add('is-opened');
      } else if (!details.open && hasOpenedClass) {
        details.classList.remove('is-opened');
      }
    });
  }
}



/****************************************
      ドロワーメニューの開閉JS
****************************************/
$(function(){
    $('.c-toggle__title').click(function(){
        $(this).toggleClass('is-active');
        $(this).next('.c-toggle__content').slideToggle(400, 'swing');
    });
});


/****************************************
      メインビジュアルのスライダーJS
****************************************/
function mvSliderTorigger() {
    if (document.querySelectorAll('.c-mvisual__section') !== null) {
        mvSlider();
    }
};

function mvSlider () {
    $('.c-mvisual__section').each(function() {
        const $slideSection = $(this);
        const $slick = $slideSection.find('.slider');
        const $arrows = $slideSection.find('.c-mvisual__arrows');
      
        let autoSpeed = 5000;
        $slick.slick({
            autoplay: true,
            autoplaySpeed: autoSpeed,
            speed: 1500,
            arrows: true,
            appendArrows: $arrows,
            dots: true,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            pauseOnHover: false,
            prevArrow: '<button class="slide-arrow prev-arrow c-circle-button animate-icon-horizontal"><span class="c-arrowsvg"></span></button>',
            nextArrow: '<button class="slide-arrow next-arrow c-circle-button animate-icon-horizontal c-reverse"><span class="c-arrowsvg"></span></button>',
        });

        $('.c-more-buttonbox').hover(
            function() {
                $slick.slick('slickPause');
            },
            function() {
                $slick.slick('slickPlay');
            }
        );

      $('body').on('click', function() {
        if ($('body').hasClass('overflow-hidden-tablet') || $('body').hasClass('overflow-hidden')) {
            $slick.slick('slickPause');
        } else {
            $slick.slick('slickPlay');
        }
      });

        const $currentSlide = $slick.find('.slick-active');
        $currentSlide.addClass('slick-init');
        setTimeout(function() {
          $slick.find('.c-mvisual__one').removeClass('slick-init');
        }, autoSpeed);
    });
};


/****************************************
      特集コレクションのスライダーJS
****************************************/
function featuredSliderTorigger() {
    if (document.querySelectorAll('.c-featured-collection__section') !== null) {
        featuredSlider();
    }
};

function featuredSlider () {
    $('.c-featured-collection__section').each(function() {
        const $slideSection = $(this);
        const $slick = $slideSection.find('.slider');
      
        let slideNum;
        slideNum = $slick.data('slideNum');
      
        $slick.slick({
            autoplay: false,
            arrows: true,
            dots: true,
            slidesToShow: slideNum,
            slidesToScroll: 1,
            infinite: false,
            prevArrow: '<button class="slide-arrow prev-arrow c-circle-button animate-icon-horizontal"><span class="c-arrowsvg"></span></button>',
            nextArrow: '<button class="slide-arrow next-arrow c-circle-button animate-icon-horizontal c-reverse"><span class="c-arrowsvg"></span></button>',
            responsive: [{
            breakpoint: 749,
                settings: {
                    slidesToShow: 2.07,
                }
            }]
        });
    });
};


/****************************************
      利用シーンから選ぶのスライダーJS
****************************************/
function sceneSliderTorigger() {
    if (document.querySelectorAll('.c-scene__section') !== null) {
        sceneSlider();
    }
};

function sceneSlider () {
    $('.c-scene__section').each(function() {
        const $slideSection = $(this);
        const $slick = $slideSection.find('.slider');
      
        $slick.slick({
            autoplay: false,
            arrows: true,
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            prevArrow: '<button class="slide-arrow prev-arrow c-circle-button animate-icon-horizontal"><span class="c-arrowsvg"></span></button>',
            nextArrow: '<button class="slide-arrow next-arrow c-circle-button animate-icon-horizontal c-reverse"><span class="c-arrowsvg"></span></button>',
            responsive: [{
            breakpoint: 749,
                settings: {
                    slidesToShow: 1.18,
                }
            }]
        });
    });
};


/****************************************
      関連商品のスライダーJS
****************************************/             
function relatedProductSliderTorigger() {
    if (document.querySelectorAll('.c-related-products__section') !== null) {
        relatedProductSlider();
    }
};

function relatedProductSlider () {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    };
  
    $('.c-related-products__section').each(function() {
       const $slideSection = $(this);

       const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            $.ajax({
                url: `/recommendations/products.json?product_id=${recommendProductId}&limit=8`,
                dataType: 'json',
                success: function(data) {
                  console.log(data)
                  $slideSection.find('.c-related-products__recommend.slider.slick-initialized').slick('unslick');
                       $slideSection.find('.c-related-products__recommend.slider').not('.slick-initialized').slick({
                          autoplay: false,
                          arrows: true,
                          dots: true,
                          slidesToShow: 4,
                          slidesToScroll: 1,
                          infinite: false,
                          prevArrow: '<button class="slide-arrow prev-arrow c-circle-button animate-icon-horizontal"><span class="c-arrowsvg"></span></button>',
                          nextArrow: '<button class="slide-arrow next-arrow c-circle-button animate-icon-horizontal c-reverse"><span class="c-arrowsvg"></span></button>',
                          responsive: [{
                          breakpoint: 749,
                              settings: {
                                  slidesToShow: 2.07,
                              }
                          }]
                      });
                      
                      $slideSection.find('.c-related-products__recommend').removeClass('is-hidden');
                      $slideSection.find('.c-loading').addClass('is-hidden');
                },
                error: function(err) {
                  console.error(err);
                }
              });
            
            observer.unobserve(entry.target);
          }
        });
      }, options);

          $slideSection.find('.c-related-products__metafield.slider').not('.slick-initialized').slick({
              autoplay: false,
              arrows: true,
              dots: true,
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: false,
              prevArrow: '<button class="slide-arrow prev-arrow c-circle-button animate-icon-horizontal"><span class="c-arrowsvg"></span></button>',
              nextArrow: '<button class="slide-arrow next-arrow c-circle-button animate-icon-horizontal c-reverse"><span class="c-arrowsvg"></span></button>',
              responsive: [{
              breakpoint: 749,
                  settings: {
                      slidesToShow: 2.07,
                  }
              }]
          });

    observer.observe($slideSection[0]);
    });
};

function relatedProductSliderDesignmode() {
  $('.c-related-products__section').each(function() {
      const $slideSection = $(this);
    
        $slideSection.find('.slider').not('.slick-initialized').slick({
            autoplay: false,
            arrows: true,
            dots: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            prevArrow: '<button class="slide-arrow prev-arrow c-circle-button animate-icon-horizontal"><span class="c-arrowsvg"></span></button>',
            nextArrow: '<button class="slide-arrow next-arrow c-circle-button animate-icon-horizontal c-reverse"><span class="c-arrowsvg"></span></button>',
            responsive: [{
            breakpoint: 749,
                settings: {
                    slidesToShow: 2.07,
                }
            }]
        });
  });
}


/****************************************
    トップへ戻るボタンJS
****************************************/
$(function(){
  const pagetop = $('.c-smoothscroll-top');

    pagetop.click(function () {
       $('body, html').animate({ scrollTop: 0 }, 500);
       return false;
    });

    function positionPcAdjust() {
      pagetop.hide();

      $(window).on("scroll", function () {
         if ($(this).scrollTop() > 60) {
              pagetop.fadeIn();
         } else {
              pagetop.fadeOut();
         }
      });
    
      $(window).on("scroll", function () {
        scrollHeight = $(document).height(); 
        scrollPosition = $(window).height() + $(window).scrollTop(); 
        footHeight = $(".c-footer-top").innerHeight() + $(".c-footer-bottom").innerHeight();
        if ((scrollHeight - scrollPosition <= footHeight - 80) && ($(window).width() >= 750)) {
          pagetop.css({ position: "absolute", bottom: footHeight }); 
        } else if ((scrollHeight - scrollPosition > footHeight - 80) && ($(window).width() >= 750)) { 
          pagetop.css({ position: "fixed", bottom: "80px" }); 
        } else {
          pagetop.css({ position: "relative", bottom: "0px" }); 
        }
      });
    }
  
    if (window.matchMedia('(min-width: 750px)').matches) {
        positionPcAdjust();
    }
  
    $(window).resize(function(){
        let width = $(window).width();
        let md = 750;
        if (width >= md) {
            positionPcAdjust();
         }
    });
  
});


/****************************************
    コレクションページフィルター最大料金の横幅調整JS
    (FireFox&Safariブラウザ対応用)
****************************************/
function colFilterMaxpriceWidthToggle() {
    if (document.querySelector('.c-price-range__max') !== null) {
        colFilterMaxpriceWidth();
    }
};

function colFilterMaxpriceWidth() {
  const priceRangeMax = document.querySelector('.c-price-range__max');
  const priceRangeMaxStyle = window.getComputedStyle(priceRangeMax);
  const priceRangeMaxFontSize = priceRangeMaxStyle.getPropertyValue('font-size');
  const priceRangeMaxRatio = Math.ceil(parseInt(priceRangeMaxFontSize) / 1.7);
  const maxPlaceholder = priceRangeMax.placeholder;
  let textWidth = priceRangeMaxRatio;

  for (let i = 0; i < 10; i++) {
    if (maxPlaceholder.length == i) {
        const textStyle = textWidth * i;
        priceRangeMax.style.width = textStyle + 'px';
    }
  }
}


/****************************************
    商品詳細ページ最後の矢印クリック時最初に戻るJS
****************************************/
const thumbnailList = document.querySelector('.product__media-wrapper .thumbnail-list');
const thumbnailListFirst = thumbnailList.firstElementChild;
const thumbnail = thumbnailListFirst.querySelector('.thumbnail');
const productArrowNext = document.querySelector('.c-product-gallery__arrows .next-arrow');

productArrowNext.addEventListener('click', () => {
    if (productArrowNext.hasAttribute('aria-disabled')) {
      thumbnail.click();
    }
});